import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

export const StayCard = ({ property, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="w-[85vw] sm:w-auto shrink-0"
    >
      <Link
        to={`/stays/${property.slug}`}
        data-testid={`stay-card-${property.slug}`}
        className="group flex h-full flex-col bg-white rounded-2xl overflow-hidden shadow-[0_8px_30px_rgba(74,49,37,0.06)] hover:shadow-[0_16px_44px_rgba(74,49,37,0.12)] transition-shadow duration-500"
      >
        {/* Image + price badge */}
        <div className="relative overflow-hidden aspect-[16/10]">
          <img
            src={property.cover}
            alt={property.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <span
            data-testid={`price-badge-${property.slug}`}
            className="absolute top-2.5 left-2.5 rounded-full bg-terracotta px-2.5 py-1 text-[11px] font-medium text-white shadow-[0_4px_12px_rgba(74,49,37,0.25)]"
          >
            Starting from ₹{property.price}/night
          </span>
        </div>

        <div className="flex flex-col flex-1 p-4">
          {/* Name */}
          <h3 className="font-serif text-xl font-semibold text-brown leading-tight">
            {property.name}
          </h3>

          {/* Locality */}
          <p className="mt-1 inline-flex items-center gap-1.5 text-xs text-brown/60">
            <MapPin className="h-3.5 w-3.5 text-gold shrink-0" /> {property.locality}
          </p>

          {/* Type + capacity */}
          <p className="mt-2.5 text-[10px] font-semibold uppercase tracking-[0.15em] text-terracotta">
            {property.category}
          </p>
          <p className="text-sm text-brown/75">{property.capacity}</p>

          {/* Important distances */}
          <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.15em] text-brown/45">
            Important Distances
          </p>
          <ul className="mt-2 space-y-1.5">
            {property.distances.map((d) => (
              <li key={d.place} className="flex items-baseline justify-between gap-4 text-[11px]">
                <span className="text-brown/60">{d.place}</span>
                <span className="text-brown/85 font-medium whitespace-nowrap">{d.km}</span>
              </li>
            ))}
          </ul>
        </div>
      </Link>
    </motion.div>
  );
};

export default StayCard;
